import React from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DatePickerSelector = ({ label, value, onChange, minDate, maxDate }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="d-flex flex-column">
        <Label>{label}</Label>
        <DatePicker
          value={value ? dayjs(value) : null}
          onChange={(date) => onChange(date ? dayjs(date).format("YYYY-MM-DD") : "")}
          minDate={minDate ? dayjs(minDate) : null}
          maxDate={maxDate ? dayjs(maxDate) : null}
        />
      </div>
    </LocalizationProvider>
  );
};

const DropdownSelector = ({ label, options, selectedValue, onSelect, isOpen, toggle }) => {
  return (
    <div className="d-flex flex-column">
      <Label>{label}</Label>
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle caret className="filter_block">
          {selectedValue} <i className="fa fa-caret-down"></i>
        </DropdownToggle>
        <DropdownMenu>
          {options.map((option) => (
            <DropdownItem key={option} onClick={() => onSelect(option)}>
              {option}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

const FilterBar = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  timeline,
  setTimeline,
  dropdownOpenTimeline,
  toggleTimeline,
  measures,
  setMeasures,
  dropdownOpenMeasures,
  toggleMeasures,
  groupBy,
  setGroupBy,
  dropdownOpenGroupBy,
  toggleGroupBy
}) => {
  return (
    <div className="d-flex justify-content-end align-items-center gap-4">
      {/* ✅ From Date */}
      <DatePickerSelector label="From Date" value={fromDate} maxDate={toDate} onChange={setFromDate} />

      {/* ✅ To Date */}
      <DatePickerSelector
        label="To Date"
        value={toDate}
        minDate={fromDate}
        onChange={setToDate}
      />

      {/* ✅ Timeline Dropdown */}
      <DropdownSelector
        label="Timeline:"
        options={["Daily", "Weekly", "Monthly", "Yearly"]}
        selectedValue={timeline}
        onSelect={setTimeline}
        isOpen={dropdownOpenTimeline}
        toggle={toggleTimeline}
      />

      {/* ✅ Measures Dropdown */}
      <DropdownSelector
        label="Measures:"
        options={["Total", "Average"]}
        selectedValue={measures}
        onSelect={setMeasures}
        isOpen={dropdownOpenMeasures}
        toggle={toggleMeasures}
      />

      {/* ✅ Group By Dropdown */}
      <DropdownSelector
        label="Group By:"
        options={["Organization", "State"]}
        selectedValue={groupBy}
        onSelect={setGroupBy}
        isOpen={dropdownOpenGroupBy}
        toggle={toggleGroupBy}
      />
    </div>
  );
};

export default FilterBar;
